import React from "react";

import * as C from "./Address.styles.js";

import DeliveryIcon from "../../assets/icons/DeliveryIcon.svg";

const Address = () => {
    return (
        <C.AddressContainer>
            <C.DeliveryOptionIcon
                src={DeliveryIcon}
                alt="Ícone do tipo de entrega"
            />
            <C.AddressInformation>
                <C.AddressMessage>Encontre nossa loja em</C.AddressMessage>
                <C.AddressDetails>Avenida Marechal Dutra, nº 346 - Centro Rondonópolis - MT</C.AddressDetails>
            </C.AddressInformation>
        </C.AddressContainer>
    );
}

export default Address;
